import HundredBricksAPI from '../../../HundredBricksAPI';
import { APIError } from '../../../../api';
import AnnualLeasingAmount, { AnnuaLeasingCannotBeLessThanOne, AnnualLeasingAmountError, CrowdfundingPropertyNotFound, InvalidAnnualLasingAmount, InvalidCrowdfundingPropertyID, TargetAnnualLeasingNotReachable } from './getAnnualLeasingAmount';
import CapitalGainAmount, { CapitalGainAmountError, CapitalGainCrowdfundingPropertyNotFound, CapitalGainInvalidCrowdfundingPropertyID, InvalidCapitalGainAmount, TargetCapitalGainNotReachable } from './getCapitalGainAmount';
import { EstimatedProfits, EstimatedProfitsError, EstimatedProfitsInvalidPropertyID, EstimatedProfitsPropertyNotFound } from './getEstimatedProfits';
import { DiscountSummary, DiscountSummaryError, DiscountSummaryInvalidPropertyID, DiscountSummaryPropertyNotFound } from './getDiscountSummary';
import { Quotation, QuotationEnoughPropertyBricks, QuotationError, QuotationInvalidNumberOfBricks, QuotationInvalidPropertyID, QuotationNumberOfBricksExceeds, QuotationNumberOfBricksLess, QuotationNumberOfBricksMinimun, QuotationPropertyNotFound } from './CalculateQuotation';
import { CouponError, Coupon, CouponNotFound, CouponNotBelongToProperty, InvalidCouponStatus, InvalidInvestorId, InvestorCouponUsed, CouponExpired, CouponNotEnoughBricksAvailable } from './Coupons';
import { ActivateCouponError, ActivateCouponInvalidPropertyId, ActivateCouponNotFound, ActivateCouponPropertyNotFound } from './getActivateCoupon';
class CrowdfundingPropertyAPI extends HundredBricksAPI {
    async getAnnualLeasingAmount(propertyId, annualLeasingAmount) {
        try {
            const queryParam = annualLeasingAmount ? `?annualLesingAmount=${annualLeasingAmount}` : '';
            const { data } = await this.client.get(
            // eslint-disable-next-line max-len
            `v1/crowdfundingProperties/${propertyId}/bricksForAnnualLeasing${queryParam}`);
            return new AnnualLeasingAmount(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_CROWDFUNDING_PROPERTY_ID':
                        throw new InvalidCrowdfundingPropertyID(propertyId, { cause: error });
                    case 'CROWDFUNDING_PROPERTY_NOT_FOUND':
                        throw new CrowdfundingPropertyNotFound(propertyId, { cause: error });
                    case 'ANUUAL_LEASING_CANNOT_BE_LESS_THAN_ONE':
                        throw new AnnuaLeasingCannotBeLessThanOne({ cause: error });
                    case 'INVALID_ANNUAL_LEASING_AMOUNT':
                        throw new InvalidAnnualLasingAmount({ cause: error });
                    case 'TARGET_ANNUAL_LEASING_NOT_REACHABLE':
                        throw new TargetAnnualLeasingNotReachable({ cause: error });
                    default:
                        throw new AnnualLeasingAmountError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new AnnualLeasingAmountError('Unexpected error when obtaining annual leasing amount', { cause: error });
            }
            else {
                throw new AnnualLeasingAmountError(`Unexpected error when obtaining annual leasing amount: '${error}'`);
            }
        }
    }
    async getCapitalGainAmount(propertyId, capitalGainAmount) {
        try {
            const queryParam = capitalGainAmount ? `?capitalGainAmount=${capitalGainAmount}` : '';
            const { data } = await this.client.get(
            // eslint-disable-next-line max-len
            `v1/crowdfundingProperties/${propertyId}/bricksForCapitalGain${queryParam}`);
            return new CapitalGainAmount(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_CROWDFUNDING_PROPERTY_ID':
                        throw new CapitalGainInvalidCrowdfundingPropertyID(propertyId, { cause: error });
                    case 'CROWDFUNDING_PROPERTY_NOT_FOUND':
                        throw new CapitalGainCrowdfundingPropertyNotFound(propertyId, { cause: error });
                    case 'INVALID_CAPITAL_GAIN_AMOUNT':
                        throw new InvalidCapitalGainAmount({ cause: error });
                    case 'TARGET_CAPITAL_GAIN_NOT_REACHABLE':
                        throw new TargetCapitalGainNotReachable({ cause: error });
                    default:
                        throw new CapitalGainAmountError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new CapitalGainAmountError('Unexpected error when obtaining capital gain amount', { cause: error });
            }
            else {
                throw new CapitalGainAmountError(`Unexpected error when obtaining capital gain amount: '${error}'`);
            }
        }
    }
    async getEstimatedProfits(propertyId) {
        try {
            const { data } = await this.client.get(`v1/crowdfundingProperties/${propertyId}/estimatedProfits`);
            return new EstimatedProfits(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_CROWDFUNDING_PROPERTY_ID':
                        throw new EstimatedProfitsInvalidPropertyID(propertyId, { cause: error });
                    case 'CROWDFUNDING_PROPERTY_NOT_FOUND':
                        throw new EstimatedProfitsPropertyNotFound(propertyId, { cause: error });
                    default:
                        throw new EstimatedProfitsError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new EstimatedProfitsError('Unexpected error when obtaining estimated profits', { cause: error });
            }
            else {
                throw new EstimatedProfitsError(`Unexpected error when obtaining estimated profits: '${error}'`);
            }
        }
    }
    async getDiscountSummary(propertyId) {
        try {
            const { data } = await this.client.get(`v1/crowdfundingProperties/${propertyId}/discountSummary`);
            return new DiscountSummary(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_CROWDFUNDING_PROPERTY_ID':
                        throw new DiscountSummaryInvalidPropertyID(propertyId, { cause: error });
                    case 'CROWDFUNDING_PROPERTY_NOT_FOUND':
                        throw new DiscountSummaryPropertyNotFound(propertyId, { cause: error });
                    default:
                        throw new DiscountSummaryError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new DiscountSummaryError('Unexpected error when obtaining estimated profits', { cause: error });
            }
            else {
                throw new DiscountSummaryError(`Unexpected error when obtaining estimated profits: '${error}'`);
            }
        }
    }
    async calculateQuotation(propertyId, bricksQuantity) {
        try {
            const { data } = await this.client.get(`v1/crowdfundingProperties/${propertyId}/quoting?numberOfBricks=${bricksQuantity}`);
            return new Quotation(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_CROWDFUNDING_PROPERTY_ID':
                        throw new QuotationInvalidPropertyID(propertyId, { cause: error });
                    case 'CROWDFUNDING_PROPERTY_NOT_FOUND':
                        throw new QuotationPropertyNotFound(propertyId, { cause: error });
                    case 'INVALID_NUMBER_OF_BRICKS':
                        throw new QuotationInvalidNumberOfBricks({ cause: error });
                    case 'NUMBER_OF_BRICKS_CAN_NOT_BE_LESS_THAN_ONE':
                        throw new QuotationNumberOfBricksLess({ cause: error });
                    case 'CROWDFUNDING_PROPERTY_DOES_NOT_HAVE_ENOUGH_AVAILABLE_BRICKS':
                        throw new QuotationEnoughPropertyBricks({ cause: error });
                    case 'NUMBER_OF_BRICKS_IS_UNDER_THE_MINIMUM_TO_BUY':
                        throw new QuotationNumberOfBricksMinimun({ cause: error });
                    case 'NUMBER_OF_BRICKS_EXCEEDS_THE_PURCHASE_LIMIT':
                        throw new QuotationNumberOfBricksExceeds({ cause: error });
                    default:
                        throw new QuotationError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new QuotationError('Unexpected error when calculating crowdfunding quotation:', { cause: error });
            }
            else {
                throw new QuotationError(`Unexpected error when calculating crowdfunding quotation: '${error}'`);
            }
        }
    }
    async activateCoupon(code, crowdfundingPropertyId) {
        try {
            const { data } = await this.client.post('v1/promotionalCoupons/activate', { code, crowdfundingPropertyId });
            return new Coupon(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'PROMOTIONAL_COUPON_NOT_FOUND':
                        throw new CouponNotFound(code, crowdfundingPropertyId, { cause: error });
                    case 'INVALID_PROMOTIONAL_COUPON_STATUS':
                        throw new InvalidCouponStatus(code, crowdfundingPropertyId, { cause: error });
                    case 'INVESTOR_ALREADY_HAS_PROMOTIONAL_COUPON_FOR_PROPERTY':
                        throw new InvestorCouponUsed(code, crowdfundingPropertyId, { cause: error });
                    case 'PROMOTIONAL_COUPON_IS_EXPIRED':
                        throw new CouponExpired(code, crowdfundingPropertyId, { cause: error });
                    case 'PROMOTIONAL_COUPON_DOES_NOT_BELONG_TO_CROWDFUNDING_PROPERTY':
                        throw new CouponNotBelongToProperty(code, crowdfundingPropertyId, { cause: error });
                    case 'NOT_ENOUGH_BRICKS_AVAILABLE':
                        throw new CouponNotEnoughBricksAvailable(code, crowdfundingPropertyId, { cause: error });
                    case 'INVALID_INVESTOR_ID':
                        throw new InvalidInvestorId({ cause: error });
                    default:
                        throw new CouponError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new CouponError('Unexpected error when obtaining coupon:', { cause: error });
            }
            else {
                throw new CouponError(`Unexpected error when obtaining coupon: '${error}'`);
            }
        }
    }
    async getActivateCoupon(crowdfundingPropertyId) {
        try {
            const { data } = await this.client.get(`v1/crowdfundingProperties/${crowdfundingPropertyId}/promotionalCoupons`);
            return new Coupon(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_CROWDFUNDING_PROPERTY_ID':
                        throw new ActivateCouponInvalidPropertyId(crowdfundingPropertyId, { cause: error });
                    case 'CROWDFUNDING_PROPERTY_NOT_FOUND':
                        throw new ActivateCouponPropertyNotFound(crowdfundingPropertyId, { cause: error });
                    case 'PROMOTIONAL_COUPON_NOT_FOUND':
                        throw new ActivateCouponNotFound({ cause: error });
                    default:
                        throw new ActivateCouponError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new ActivateCouponError('Unexpected error when obtaining coupon:', { cause: error });
            }
            else {
                throw new ActivateCouponError(`Unexpected error when obtaining coupon: '${error}'`);
            }
        }
    }
}
export default CrowdfundingPropertyAPI;
